import type { LevelDefinition } from '../world/LevelDefinition';

const surfaces = {
  floor: { enabled: true, magnetic: true },
  ceiling: { enabled: true, magnetic: true },
  left: { enabled: true, magnetic: true },
  right: { enabled: true, magnetic: true },
  front: { enabled: true, magnetic: true },
  back: { enabled: true, magnetic: true },
};

const ceilingLights = (zs: number[]) =>
  zs.map((z) => ({
    position: [0, 3.1, z] as [number, number, number],
    size: [1.6, 0.08, 1] as [number, number, number],
  }));

/**
 * Jefferies Spine: a low, narrow maintenance corridor in three linked sections.
 * It is the close-quarters level: the ceiling is only 3.2 m up, so wall and
 * ceiling fights happen at arm's length.
 */
export const JEFFERIES: LevelDefinition = {
  id: 'jefferies',
  name: 'Jefferies Spine',
  size: [5, 3.2, 38],
  surfaces,
  zones: [
    { id: 'spine-a', origin: [0, 0, 6], size: [5, 3.2, 14] },
    { id: 'spine-b', origin: [0, 0, -7], size: [5, 3.2, 12] },
    { id: 'spine-c', origin: [0, 0, -19], size: [5, 3.2, 12] },
  ],
  portals: [
    {
      id: 'a-b',
      a: 'spine-a',
      b: 'spine-b',
      axis: 'x',
      position: [0, 0, -1],
      width: 2.4,
      height: 2.6,
    },
    {
      id: 'b-c',
      a: 'spine-b',
      b: 'spine-c',
      axis: 'x',
      position: [0, 0, -13],
      width: 2.4,
      height: 2.6,
    },
  ],
  spawn: { zone: 'spine-a', surface: 'floor', position: [0, 0, 11], facing: 0 },
  targets: [
    { type: 'drone', zone: 'spine-a', surface: 'floor', position: [0, 0, 2] },
    { type: 'drone', zone: 'spine-b', surface: 'floor', position: [0, 0, -7] },
    { type: 'drone', zone: 'spine-c', surface: 'floor', position: [0, 0, -19] },
    { type: 'drone', zone: 'spine-b', surface: 'ceiling', position: [0, 3.2, -12] },
    { type: 'drone', zone: 'spine-c', surface: 'left', position: [-2.5, 1.6, -24] },
  ],
  obstacles: [
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-a',
      position: [1.6, 0.55, 7],
      size: [1.6, 1.1, 0.7],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-a',
      position: [-1.6, 0.55, 0],
      size: [1.6, 1.1, 0.7],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-b',
      position: [1.6, 0.55, -5],
      size: [1.6, 1.1, 0.7],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-b',
      position: [-1.6, 0.55, -10],
      size: [1.6, 1.1, 0.7],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-c',
      position: [1.6, 0.55, -17],
      size: [1.6, 1.1, 0.7],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine-c',
      position: [-1.6, 0.55, -23],
      size: [1.6, 1.1, 0.7],
    },
  ],
  style: {
    wallColor: 0x232a33,
    floorColor: 0x161b21,
    ceilingColor: 0xbfccd8,
    pathColor: 0xffb347,
    path: [
      { from: [0, 13], to: [0, -1], width: 1.6 },
      { from: [0, -1], to: [0, -13], width: 1.6 },
      { from: [0, -13], to: [0, -25], width: 1.6 },
    ],
    ceilingLights: ceilingLights([10, 4, -2, -8, -14, -20, -24]),
  },
  seed: 8191,
};
